import { render, staticRenderFns } from "./ClientDialog.vue?vue&type=template&id=73458c81&scoped=true"
import script from "./ClientDialog.vue?vue&type=script&lang=js"
export * from "./ClientDialog.vue?vue&type=script&lang=js"
import style0 from "./ClientDialog.vue?vue&type=style&index=0&id=73458c81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73458c81",
  null
  
)

export default component.exports